import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header
      className="w-full"
      style={{
        backgroundColor: 'var(--dreamdev-dark)',
        color: 'var(--dreamdev-text-white)',
        fontFamily: 'var(--dreamdev-font-family)'
      }}
    >
      <div
        className="mx-auto px-4 py-5 w-full"
        style={{ maxWidth: '1200px' }}
      >
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center">
              <img
                src="/logos/dd_logo_horizontal_mini.svg"
                alt="DreamDev"
                className="h-8 w-auto"
                style={{ maxHeight: '32px' }}
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a
              href="https://www.dreamdev.io/about-us"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors duration-200"
              style={{
                color: 'var(--dreamdev-text-light)',
                fontSize: 'var(--dreamdev-font-size-base)',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => (e.target as HTMLElement).style.color = 'var(--dreamdev-text-white)'}
              onMouseLeave={(e) => (e.target as HTMLElement).style.color = 'var(--dreamdev-text-light)'}
            >
              About Us
            </a>
            <a
              href="https://www.dreamdev.io/services"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors duration-200"
              style={{
                color: 'var(--dreamdev-text-light)',
                fontSize: 'var(--dreamdev-font-size-base)',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => (e.target as HTMLElement).style.color = 'var(--dreamdev-text-white)'}
              onMouseLeave={(e) => (e.target as HTMLElement).style.color = 'var(--dreamdev-text-light)'}
            >
              Services
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2"
            style={{ color: 'var(--dreamdev-text-white)' }}
          >
            <FontAwesomeIcon
              icon={isMobileMenuOpen ? faTimes : faBars}
              className="w-6 h-6"
            />
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-gray-700 pt-4">
            <div className="flex flex-col space-y-4">
              <a
                href="https://www.dreamdev.io/about-us"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors duration-200 py-2"
                style={{
                  color: 'var(--dreamdev-text-light)',
                  fontSize: 'var(--dreamdev-font-size-base)',
                  fontWeight: '500'
                }}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                About Us
              </a>
              <a
                href="https://www.dreamdev.io/services"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors duration-200 py-2"
                style={{
                  color: 'var(--dreamdev-text-light)',
                  fontSize: 'var(--dreamdev-font-size-base)',
                  fontWeight: '500'
                }}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Services
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}